import { useSelector } from "react-redux";
import type { CalculationType } from "../../../../../../../../api/types/fieldConfigurationTypes";
import { selectReportType } from "../../../../store/selectors/fieldsStateSelectors";
import { selectCurrentDataSetId } from "../../../../store/selectors/metaDataSelectors";
import { getAvailableCalculationTypes } from "../fields/custom-field/utilities/calculationTypeCapabilities";

const useAvailableCalculationTypes = (): CalculationType[] => {
  const dataSetId = useSelector(selectCurrentDataSetId);
  const reportType = useSelector(selectReportType);
  return getAvailableCalculationTypes(dataSetId, reportType);
};

export default useAvailableCalculationTypes;
